import { useCallback, useRef } from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";

import { fitTextListToContent, isNotNullOrWhiteSpace } from "Utils/String";
import { computeInnerDimensions } from "Utils/Node";
import { IOverflowDropdownProps } from "./IOverflowDropdownProps";
import { useOverflowDropdownStyles } from "./UseOverflowDropdownStyles";

export function OverflowDropdown(props: IOverflowDropdownProps): JSX.Element {
  const { usedFont, styleSet, errorMessage } = props;
  const { overflowFont, styles } = useOverflowDropdownStyles(styleSet);
  const ref = useRef<HTMLDivElement>();

  const onRenderTitle = useCallback(
    (selectedOptions: IDropdownOption[]) => (
      <>
        {fitTextListToContent(
          selectedOptions.map((opt) => opt.text),
          computeInnerDimensions(ref.current.querySelector(`.ms-Dropdown-title`)).width,
          isNotNullOrWhiteSpace(usedFont) ? usedFont : overflowFont
        )}
      </>
    ),
    [overflowFont, usedFont]
  );

  return (
    <Dropdown
      ref={ref}
      onRenderTitle={onRenderTitle}
      dropdownWidth="auto"
      {...props}
      className={styles.root}
      errorMessage={errorMessage}
    />
  );
}
